// extracted by mini-css-extract-plugin
export default {"container":"FKeBxadSJ9lH3wr0oIAM","title":"ZyK14TqteWCJYCaVEU62"};